import React from 'react'
import Container from 'react-bootstrap/Container';
import careers from '../Assets/Careers.png';
function Careers() {

  return (
    <Container fluid className='m-0 p-0' >

      <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
        <Container>


          <h2 class="text-white pt-3">Careers</h2>



        </Container>

      </div>

      <Container>

        <div class="row mt-4">
          <div class=" col-md-6">
            <p style={{ textAlign: 'justify', paddingRight: '8%' }}>
              Careers AI Pharma Exchange is an innovative platform that bridges the gap between the pharmaceutical and artificial intelligence industries. It serves as a dynamic hub for professionals seeking career opportunities, employers searching for talent, and organizations looking to drive innovation at the intersection of AI and pharma. The company offers a range of services, including recruitment, talent acquisition, networking, and career development, helping individuals and businesses navigate the rapidly evolving landscape of healthcare technology.

            </p>
            <p style={{ textAlign: 'justify', paddingRight: '8%' }}>By leveraging AI-driven tools and insights, Careers AI Pharma Exchange enables job seekers to find roles that align with their skills and aspirations while providing companies with access to top-tier talent in AI and pharma. The platform supports professionals at all career stages, from entry-level to executive positions, and fosters collaborations that drive advancements in drug development, personalized medicine, and healthcare solutions. Whether you're looking to advance your career, recruit top talent, or explore cutting-edge innovations, Careers AI Pharma Exchange is your gateway to success in this transformative sector.
            </p>



          </div>
          <div class=" col-md-6"> <img src={careers} alt='Employment Exchange' style={{ width: '70%' }} className='img-fluid' />  </div>
        </div>


      </Container>
      <div class="container ">
        <h2 class="text-center mb-4">Open Positions</h2>


        <div class="row">

          <div class="col-md-6 mb-4">
            <div class="card" style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }}>
              <div class="card-body">
                <h3 class="card-title">Career Growth with AI Pharma Exchange            </h3>
                <p class="card-text">Position: AI Specialist / Data Scientist
                </p>
                <p class="card-text">Location: Remote or Hybrid (depending on location)
                </p>
                <button className='rounded-button text-decoration-none float-end' >Apply Now</button>
              </div>
            </div>
          </div>


          <div class="col-md-6 mb-4">
            <div class="card" style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }}>
              <div class="card-body">
                <h3 class="card-title">Career Growth with AI Pharma Exchange            </h3>
                <p class="card-text">Position: AI Specialist / Data Scientist
                </p>
                <p class="card-text">Location: Remote or Hybrid (depending on location)
                </p>
                <button className='rounded-button text-decoration-none float-end' >Apply Now</button>
              </div>
            </div>
          </div>
        </div>



      </div>
    </Container>

  );


}

export default Careers